/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_User_Profile_Card_DescriptionInputs */

const es_walkthrough_user_profile_card_description = /** @type {(inputs: Walkthrough_User_Profile_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acá podés ver tu avatar, nombre, email y cuántos mensajes usaste este mes. Hacé clic en el lápiz para editar tu nombre o foto de perfil.`)
};

const en_walkthrough_user_profile_card_description = /** @type {(inputs: Walkthrough_User_Profile_Card_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here you can see your avatar, name, email, and how many messages you've used this month. Click the pencil to edit your display name or profile picture.`)
};

/**
* | output |
* | --- |
* | "Here you can see your avatar, name, email, and how many messages you've used this month. Click the pencil to edit your display name or profile picture." |
*
* @param {Walkthrough_User_Profile_Card_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_user_profile_card_description = /** @type {((inputs?: Walkthrough_User_Profile_Card_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_User_Profile_Card_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_user_profile_card_description(inputs)
	return en_walkthrough_user_profile_card_description(inputs)
});
export { walkthrough_user_profile_card_description as "walkthrough.user_profile_card_description" }